module.exports = __webpack_public_path__ + "static/media/survey_icon.c844f792.svg";